<cw-banner
  type="warning"
  [description]="'OrganizationSettingsEditConfirmationMessage' | translate"
  [label]="'OrganizationSettingsEditConfirmationMessageSubTitle' | translate"
  [enableClose]="false"
></cw-banner>
